import { license as licenseSelector } from '@Containers/UserDetails/UserDetailsSelectors';
import { heatmapLicenseCheck } from '@Pages/Heatmap/selectors';

export const isHeatmapAvailable = (state) => {
  const license = licenseSelector(state);
  return heatmapLicenseCheck(license);
};

export const isHeatmapDisabled = (state, { resultsCount } = {}) => !resultsCount;
